/* unplugin-vue-components disabled */import script from "./productOptions.vue?vue&type=script&lang=ts&setup=true"
export * from "./productOptions.vue?vue&type=script&lang=ts&setup=true"

import "./productOptions.vue?vue&type=style&index=0&id=ac4a00e4&lang=scss"

const __exports__ = script;

export default __exports__